// 时间格式化
export function timeFormat(val) {
    if (val !== null) {
        var year = val.getFullYear(); //得到年份
        var month = val.getMonth(); //得到月份
        var date = val.getDate(); //得到日期
        month = month + 1;
        month = month.toString().padStart(2, "0");
        date = date.toString().padStart(2, "0");
        var defaultDate = `${year}${month}${date}`;
        return defaultDate;

    }
}
// 时间格式化
export function Timecl(data) {
    data.map((item) => {
        // 车间交期
        if (item.EFFECTDATE != 0) {
            item.EFFECTDATE = item.EFFECTDATE + "";
            var dd = item.EFFECTDATE.slice(0, 4);
            var dt = item.EFFECTDATE.slice(4, 6);
            var dm = item.EFFECTDATE.slice(6, 8);
            var t = dd + "-" + dt + "-" + dm;
            item.time = t
        } else {
            item.time = 0
        }
        if (item.BILLDATE != 0) {
            item.BILLDATE = item.BILLDATE + "";
            var year = item.BILLDATE.slice(0, 4);
            var month = item.BILLDATE.slice(4, 6);
            var date = item.BILLDATE.slice(6, 8);
            var datatime = year + "-" + month + "-" + date;
            // console.log(t);
            item.datatime = datatime
            // console.log(item.time);
        } else {
            item.datatime = 0
        }
    });
    return data;
}